module.exports = __webpack_public_path__ + "img/4.c0e996d7.jpg";